(() => {
  const getRequestParams = () => {
    return {
      customerId: window.customer.id,
      userName: window.customer.userName,
      userNumber: window.customer.currentUserNumber,
    };
  };

  class MainCalendar extends Modal {
    static elementName = 'main-calendar';
    static routes = {
      SET_DELIVERY_DATE: '/apps/stroetmann/api/v1/customers/set_current_delivery_date',
    }

    constructor() {
      super();

      this._enableLog = false;
      this._selectedDate = null;
      this._loading = false;

      this.log('Initialising', this, { ...this });
      this.config = this.getConfig();
      this.log('Configuration:', this.config);
      this.elems = /** @type {ReturnType<typeof this.getElems>} */ (this.getElems());
      this.log('Elements:', this.elems);
      this.currentCart = LocalCart.getState();
    }

    connectedCallback() {
      //console.log(`Date config >>`, this.config);

      this.selectedDate = this.config.initialDate;
      this.initCalendar();
      
      // console.log('📅 Calendar: Setting up confirm button...', this.elems.confirmButton);
      this.elems.confirmButton?.addEventListener('click', () => {
        console.log('📅 Calendar: Confirm button clicked!');
        this.handleSetDeliveryDate();
      });
      
      this.addEventListener('modal:on:close', (event) => {
        setTimeout(() => {
          //this.selectedDate = this.config.initialDate;
          this.initCalendar();
        }, 350);
      });

      document.addEventListener('main-calendar:on:open', () => {
        this.setAttribute('open', 'true');
      });

      document.addEventListener('main-calendar:date:clear', async () => {

        this.selectedDate = null;
        this.calendar.selectedDates = [];

        const url = new URL(`${location.origin}${MainCalendar.routes.SET_DELIVERY_DATE}`);
        const { customerId, userName, userNumber } = getRequestParams();

        const requestBody = {
          customerId,
          userName,
          userNumber,
          date: '0',
        };

        await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });
        
        LocalCart.updateAttr({"current_date": ""});

        const formData = new FormData();
        formData.append('attributes[current_date]', ``);
        
        // Don't set Content-Type for FormData - let browser set it automatically
        const clearHeaders = window.getCartHeaders ? window.getCartHeaders() : {};
        delete clearHeaders['Content-Type']; // Remove Content-Type for FormData
        

        await fetch(`${window.theme.routes.cartUpdate}.js`, {
          method: 'POST',
          headers: clearHeaders,
          body: formData,
        });

        //clear AssortmentCache from IDB
        if (AssortmentCache) AssortmentCache.clear().catch(() => {});

      });

      // console.log(`this.selectedDate >>`,this.selectedDate)
      
      if(window.location.pathname != '/pages/thank-you'){
        //check if delivery date added in the header calender view but not in cart attributes.
        if (this.selectedDate && (this.currentCart.attributes?.current_date == null || this.currentCart.attributes?.current_date == "")) {
          console.log('📅 Calendar: date selected - Cart attribute does not have');
          document.dispatchEvent(new CustomEvent('main-calendar:on:open', { bubbles: true }));
        }

        //check if delivery date added in the cart attributes but not set in the calender view.
        if (this.selectedDate === null && (this.currentCart.attributes?.current_date != null && this.currentCart.attributes?.current_date != "")) {
          console.log('📅 Calendar: No date selected - Cart have date attribute');
          document.dispatchEvent(new CustomEvent('main-calendar:on:open', { bubbles: true }));
        }
      }
      

    }

    /**
     * Handles 'click' events on the modal.
     * This replaces the original handleClick method of the Modal class
     * as when no date is selected and the modal is open, then
     * it shouldn't be possible to close it until a date has been confirmed
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (evt.target !== this && !evt.target.matches('.js-close-modal')) return;
      if (this.config.initialDate === null || (this.currentCart.attributes?.current_date == null || this.currentCart.attributes?.current_date == "")) return;
      this.close();
    }

    /**
     * Override close method to add debugging
     */
    close() {
      console.log('📅 Calendar: close() method called');
      super.close();
      console.log('📅 Calendar: super.close() completed');
    }

    initCalendar() {
      this.calendar = new VanillaCalendar(this.elems.container, this.getCalendarOptions());
      this.calendar.init();

      // document.dispatchEvent(new CustomEvent('main-calendar:on:ready'));

    }

    async handleSetDeliveryDate() {
      console.log('📅 Calendar: handleSetDeliveryDate called');
      console.log('📅 Calendar: Current _loading state:', this._loading);
      
      if (this._loading) {
        console.log('📅 Calendar: Already loading, skipping');
        return;
      }
      
      console.log('📅 Calendar: Not loading, proceeding with date update');

      try {
        console.log('📅 Calendar: Entering try block');
        console.log('📅 Calendar: Current selectedDate:', this.selectedDate);
        console.log('📅 Calendar: selectedDate === null?', this.selectedDate === null);
        
        if (this.selectedDate === null) {
          console.log('📅 Calendar: No date selected - throwing error');
          throw new Error('No Date selected');
        }
        
        console.log('📅 Calendar: Date validation passed, setting loading state');
        console.log('📅 Calendar: Setting loading state and updating date:', this.selectedDate);
        this.loading = true;

        const url = new URL(`${location.origin}${MainCalendar.routes.SET_DELIVERY_DATE}`);
        const { customerId, userName, userNumber } = getRequestParams();

        const requestBody = {
          customerId,
          userName,
          userNumber,
          date: this.selectedDate.toISOString(),
        };

        this.log('Updating Delivery Date', requestBody);

        console.log('📅 Calendar: Updating backend delivery date...', requestBody);
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('📅 Calendar: Backend delivery date error response:', errorText);
          throw new Error(`Backend delivery date update failed: ${response.status} - ${errorText}`);
        }
        
        const backendResponse = await response.json();
        console.log('📅 Calendar: Backend delivery date updated successfully', backendResponse);

        const dateString = this.selectedDate.toISOString();
        this.selectedDate = new Date(dateString);
        this.calendar.selectedDates = [this.selectedDate];

        LocalCart.updateAttr({"current_date": this.selectedDate});
        // Local cart update event so latest cart saved to metafield
        if(sharedCart && Object.keys(sharedCart).length){
          await sharedCart.handleCartChange();
        }

        const formData = new FormData();
        formData.append('attributes[current_date]', dateString);        
        // Don't set Content-Type for FormData - let browser set it automatically
        const headers = window.getCartHeaders ? window.getCartHeaders() : {};
        delete headers['Content-Type']; // Remove Content-Type for FormData        
        await fetch(`${window.theme.routes.cartUpdate}.js`, {
          headers: headers,
          method: 'POST',
          body: formData,
        });

        console.log('✅ Calendar: Delivery date updated');
        console.log('📅 Calendar: Final selectedDate value:', this.selectedDate);
        console.log('📅 Calendar: Updating header elements...');
        console.log('📅 Calendar: headerWeekday element:', this.elems.headerWeekday);
        console.log('📅 Calendar: headerDate element:', this.elems.headerDate);

        //clear AssortmentCache from IDB
        if (AssortmentCache) AssortmentCache.clear().catch(() => {});

        // Check if header date elements exist
        if (this.elems.headerWeekday && this.elems.headerDate) {
          // Elements exist, update them directly
          const weekdayText = this.dateToLocaleDateString(this.selectedDate, {
            weekday: 'long'
          });
          const dateText = Intl.DateTimeFormat('de-DE', { month: '2-digit', day: '2-digit' }).format(this.selectedDate);
          
          console.log('📅 Calendar: Setting weekday to:', weekdayText);
          console.log('📅 Calendar: Setting date to:', dateText);
          
          this.elems.headerWeekday.innerHTML = weekdayText;
          this.elems.headerDate.innerHTML = dateText;
        } else {
          // Elements don't exist (no date was selected before), need to update the entire header section
          console.log('📅 Calendar: Header date elements not found, updating via header section refresh');
          
          const headerDateContainer = document.querySelector('#nav-date');
          if (headerDateContainer) {
            const weekdayText = this.dateToLocaleDateString(this.selectedDate, {
              weekday: 'long'
            });
            const dateText = Intl.DateTimeFormat('de-DE', { month: '2-digit', day: '2-digit' }).format(this.selectedDate);
            
            console.log('📅 Calendar: Creating new header date elements');
            console.log('📅 Calendar: Weekday:', weekdayText);
            console.log('📅 Calendar: Date:', dateText);
            
            headerDateContainer.innerHTML = `
              <span class="weekday" data-header-weekday>${weekdayText}</span>
              <span class="text-body-small date" data-header-date>${dateText}</span>
            `;
          } else {
            console.log('📅 Calendar: Header date container #nav-date not found');
          }
        }

        console.log('📅 Calendar: Process completed successfully, closing modal...');

        // Refresh cart sections delivery date element
        const cartDateEle = document.querySelector(`cart-checkout .cart-delivery-date-element`);
        if(cartDateEle){
          cartDateEle.innerHTML = Intl.DateTimeFormat('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit', year: '2-digit' }).format(this.selectedDate);
        }

        console.log('✅ Local Cart: Delivery date updated');

        //show modal indicating delivery date change
        const dateChangeModal = document.getElementById('dateChangeModal');
        if(dateChangeModal) dateChangeModal.setAttribute(`open`,``);
        window.location.reload();

      } catch (error) {
        console.error('📅 Calendar: Error updating Delivery Date:', error);
        this.log('Error updating Delivery Date', error);
      } finally {
        // Always close the modal and reset loading state
        console.log('📅 Calendar: Cleaning up - closing modal and resetting loading state');
        this.loading = false;
        
        console.log('📅 Calendar: About to call close(), modal has open attribute:', this.hasAttribute('open'));
        this.close();
        console.log('📅 Calendar: Called close(), modal has open attribute:', this.hasAttribute('open'));
      }
    }

    /**
     * Formats date into string accepted by Vanilla Calendar
     * 
     * @param {string | Date} date 
     * 
     * @returns {string} 
     */
    vanillaCalendarFormatDate(date) {
      const dateObj = new Date(date);
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const dateOfMonth = dateObj.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${dateOfMonth}`;
    }

    handleUpdateSelectedDate(newDate) {
      this.selectedDate = newDate ? new Date(newDate) : null;
    }

    get loading() {
      return this._loading;
    }

    set loading(value) {
      this._loading = value;

      if (!this.elems?.confirmButton) return;

      const operation = value ? 'add' : 'remove';
      this.elems.confirmButton.disabled = value;
      this.elems.confirmButton.classList[operation]('btn--loading');
    }

    /**
     * @returns {Date | null}
     */
    get selectedDate() {
      return this._selectedDate;
    }

    /**
     * @param {Date | null} newDate - The date object
     */
    set selectedDate(newDate) {
      this._selectedDate = newDate;
      this.clearMessage();

      this.elems.confirmButton.disabled = newDate === null;

      if (newDate === null) {
        this.elems?.choose?.classList.remove('hidden');
        this.elems?.selected?.classList.add('hidden');
        return;
      }

      this.elems?.choose?.classList.add('hidden');
      const dateString = this.dateToLocaleDateString(newDate);

      this.elems.weekdayText.innerHTML = this.dateToLocaleDateString(newDate, {
        weekday: 'long'
      });
      this.elems.dateText.innerHTML = dateString;
      this.elems?.selected?.classList.remove('hidden');

      const showSameDayWarning = (() => {
        const todayDateString = this.dateToLocaleDateString(new Date());
        return dateString === todayDateString;
      })();

      if (showSameDayWarning) {
        this.showMessage(this.config.strings['general.datepicker.same_day_warning']);
      }
    }

    clearMessage() {
      this.elems.messageContainer.innerHTML = '';
      this.elems.messageContainer.classList.add('hidden');
    }

    showMessage(message, type = 'error') {
      const className = (() => {
        switch (type) {
          case 'success':
            return 'bg-success-bg text-success-text';
          case 'error':
          default:
            return 'bg-error-bg text-error-text'
        }
      })();

      const html = `
        <div class="alert reading-width mb-8 mx-auto ${className} js-customer-form-message" tabindex="-1" autofocus>
          ${message}
        </div>
      `;

      this.elems.messageContainer.innerHTML = html;
      this.elems.messageContainer.classList.remove('hidden');
    }

    /**
     * Docs: https://v2.vanilla-calendar.pro/docs/reference/main/main-settings
     */
    getCalendarOptions() {
      const initialDate = this.selectedDate || this.config.initialDate;
      this.initialDate = initialDate
      const { dateMin, dateMax, rangeMin, rangeMax } = this.getFormattedDateRanges();
      const disabledDates = this.config.disabledDates ? this.config.disabledDates.map(date => this.vanillaCalendarFormatDate(date)) : [];
      const weekendOverrideDates = this.config.weekendDatesOverride ? this.config.weekendDatesOverride.map(date => this.vanillaCalendarFormatDate(date)) : [];
      const customerDates = this.config.customerAvailableDates ? this.config.customerAvailableDates.map(date => this.vanillaCalendarFormatDate(date)) : [];
      const enabledDates = [...weekendOverrideDates, ...customerDates]
        .filter(date => {
          const todayDate = new Date();
          todayDate.setUTCHours(0, 0, 0, 0);
          return todayDate <= new Date(date)
        });

      if (this.config.disableToday) {
        disabledDates.push(this.vanillaCalendarFormatDate(new Date()));
      }

      return {
        date: {
          min: dateMin,
          max: dateMax,
        },
        settings: {
          range: {
            min: rangeMin,
            max: rangeMax,
            //disableWeekday: [0, 6],
            disabled: disabledDates,
            disableAllDays: this.config.hasRestrictedDates,
            enabled: enabledDates
          },
          visibility: {
            themeDetect: false,
            theme: 'light',
            disabled: true,
            weekend: false,
            daysOutside: true,
            today: false,
          },
          iso8601: false,
          selected: {
            ...(initialDate ? { dates: [initialDate] } : {}),
          },
          lang: this.config.lang,
        },
        actions: {
          clickDay: (e, self) => {
            this.handleUpdateSelectedDate(self.selectedDates[0]);
          },
        },
        toggleSelected: false,
        jumpToSelectedDate: true,
      }
    }

    getFormattedDateRanges() {
      const todayDate = new Date();
      const startOfMonthDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);;
      const inTwoMonthsDate = (() => {
        const date = new Date();
        date.setMonth(date.getMonth() + 2);
        return date;
      })();
      const endOfMonthInTwoMonthsDate = new Date(inTwoMonthsDate.getFullYear(), inTwoMonthsDate.getMonth() + 1, 0);

      return {
        // Beginning of this month
        dateMin: this.vanillaCalendarFormatDate(startOfMonthDate),
        // End of the month in 2 months
        dateMax: this.vanillaCalendarFormatDate(endOfMonthInTwoMonthsDate),
        // Today
        rangeMin: this.vanillaCalendarFormatDate(todayDate),
        // 2 Months from now
        rangeMax: this.vanillaCalendarFormatDate(inTwoMonthsDate)
      }
    }

    dateToLocaleDateString(date, options = {}) {
      const dateObject = new Date(date);
      return dateObject.toLocaleDateString(this.config.lang, options);
    };

    getElems() {
      return {
        modal: this.closest('modal-dialog'),
        confirmButton: this.querySelector('.js-main-calendar-confirm-button'),
        container: this.querySelector('.js-main-calendar-container'),
        selected: this.querySelector('.js-main-calendar-selected'),
        choose: this.querySelector('.js-main-calendar-choose'),
        messageContainer: this.querySelector('.js-main-calendar-message-container'),
        weekdayText: this.querySelector('.js-main-calendar-weekday-text'),
        dateText: this.querySelector('.js-main-calendar-date-text'),
        headerWeekday: document.querySelector('[data-header-weekday]'),
        headerDate: document.querySelector('[data-header-date]')
      }
    }

    getConfig() {
      const config = JSON.parse(this.querySelector('[data-config]')?.innerHTML || '{}');

      return {
        ...config,
        initialDate: config.initialDate ? new Date(config.initialDate) : null,
      }
    }

    log(...args) {
      if (!this._enableLog) return;
      console.log('[MainCalendar]', ...args);
    }
  }

  customElements.define(MainCalendar.elementName, MainCalendar);
})();